// extracted by mini-css-extract-plugin
module.exports = {"timeline-indicator":"timeline-indicator_timeline-indicator__QdCT3","shadow":"timeline-indicator_shadow__2F8uv"};